import { Component } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { RouterSelectors } from '@next/core-lib/router-store';
import { AccessRoleTypes, UserSelectors } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { ApplicationKeys } from 'src/app/shared/models';

@Component({
  selector: 'app-settings-navigation',
  templateUrl: 'settings-navigation.component.html',
  standalone: false,
})
export class SettingsNavigationComponent {
  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));
  isBarn$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('settings/barn') > 0),
  );
  isSustainability$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('settings/sustainability') > 0),
  );
  showSustainability$: Observable<boolean> = this.store
    .select(UserSelectors.selectUserApplications)
    .pipe(
      map((apps) =>
        apps.some(
          (app) =>
            app.ApplicationKey === ApplicationKeys.PoultryNextSustainability &&
            app.RoleKey === AccessRoleTypes.GlobalAdministrator,
        ),
      ),
    );

  constructor(private readonly store: Store<RootState>) {}
}
